import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom"; // Change this import
import {
  logActivity,
  fetchOrganizations,
  cleanupAllListeners,
  initializeDirectorySync,
  updateDataImmediately,
  
  fetchUserRatingAndReviews,
} from "../../../store/profileSlice";

import {
  Camera,
  Clock,
  Loader,
  Pencil,
  Star,
  Trash2,
  X,
  Building2,
  Search,
} from "lucide-react";
import csc from "countrycitystatejson";

import Layout from "../../../components/layout/layout";
import { TabGroup } from "../../../components/tabs/Tabs";
import { SearchHeader } from "../../../components/seachHeader/SearchHeader";
import {
  collection,
  doc,
  query,
  updateDoc,
  where,
  getDocs,
  addDoc,
} from "firebase/firestore";
import { db, storage } from "../../../config/firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
// Import a default user image for the profile
import Userimg from "../../../assets/image/user.png";
import { AppDispatch, RootState } from "../../../store";
import { NotepadText } from "lucide-react";
// Helper function to generate unique activityId with prefixes
import noActivityImg from "../../../assets/image/emtyimg.png";
import { getStateFullName } from "../../../common/AddressControl/stateNameMapper";
import { getCountryFullName } from "../../../common/AddressControl/countryNameMapper";

export function DirectoryComponents() {
  const location = useLocation(); // Change this
  const dispatch = useDispatch<AppDispatch>();
  // Redux selectors
  const user = useSelector((state: RootState) => state.profile.user);

  // Separate selectors for customers and experts
  const customers = useSelector((state: RootState) => state.profile.customers);
  const experts = useSelector((state: RootState) => state.profile.experts);
  const customersLoading = useSelector(
    (state: RootState) => state.profile.customersLoading
  );
  const expertsLoading = useSelector(
    (state: RootState) => state.profile.expertsLoading
  );
  const customersError = useSelector(
    (state: RootState) => state.profile.customersError
  );
  const expertsError = useSelector(
    (state: RootState) => state.profile.expertsError
  );

  // Backward compatibility - for legacy components that might still use allUsers
  const allUsers = useSelector((state: RootState) => state.profile.allUsers);

  const organizations = useSelector(
    (state: RootState) => state.profile.organizations
  );
  console.log(organizations, "organizations");

  // Add selectors for user ratings
  const userRatings = useSelector(
    (state: RootState) => state.profile.userRatings
  );
  const ratingsLoading = useSelector(
    (state: RootState) => state.profile.ratingsLoading
  );
  const [isEditOpen, setEditOpen] = useState<boolean>(false);
  const [setupTeamModel, setSetupTeamModel] = useState<boolean>(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [profileViewModel, setProfileViewModel] = useState<boolean>(false);
  const [selectedMember, setSelectedMember] = useState<any>(null);
  const [viewModelSelectedMember, setViewModelSelectedMember] =
    useState<any>(null);
  console.log(viewModelSelectedMember, "viewModelSelectedMember");
  const [expertModalOpen, setExpertModalOpen] = useState<boolean>(false);
  console.log(selectedMember, "selectedMember");
  const [formData, setFormData] = useState({
    orgName: "",
    orgUrl: "",
    teamName: "",
    taxId: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    orgId: "", // Add orgId field
  });
  const [viewData, setViewData] = useState<any>({});
  const [profileData, setProfileData] = useState<any>(null);
  const [customSpecialties, setCustomSpecialties] = useState<string[]>([]);
  console.log(viewData, "viewData");

  // Define specialty options for Expert profiles
  const specialtyOptions = [
    "Full-service implementations",
    "Account setup",
    "Project-oriented workflows",
    "Process-oriented workflows",
    "Templates",
    "Reporting",
    "Admin",
    "Security",
    "Customisation",
    "Integrations & APIs",
    "New user onboarding",
    "Disaster recovery",
    "Dashboard setup",
    "Data migration",

    "Others (Specify)",
  ];
  // Function to get team role display text
  const getTeamRoleDisplay = (role: string) => {
    switch (role) {
      case "expert_owner":
        return "Team Owner";
      case "customer_owner":
        return "Team Owner";
      case "expert_team_lead":
        return "Team Lead";
      case "customer_team_lead":
        return "Team Lead";
      case "expert_team_member":
        return "Team Member";
      case "customer_team_member":
        return "Team Member";
      case "Expert":
        return "Expert";
      case "Customer":
        return "Customer";
      default:
        return "Expert";
    }
  };
  // Initial redirect check
  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);

  const [activeTab, setActiveTab] = useState("customer");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState<any>(null);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [selectedEditUserId, setSelectedEditUserId] = useState<string | null>(
    null
  );
  const [teamNameError, setTeamNameError] = useState<string>("");
  const [orgNameError, setOrgNameError] = useState<string>("");
  console.log(selectedEditUserId, "selectedEditUserId");
  const itemsPerPage = 10;
  console.log(activeTab, "activeTab");
  const tabs = [
    { label: "Customer", value: "customer" },
    { label: "Expert", value: "expert" },
  ];
  const getStatusColor = (disabled: boolean | undefined): string => {
    // disabled is a boolean - true means account is disabled/deactivated
    if (disabled === true) {
      return "bg-[#D5332A] border-[15px] border-red-50"; // Red for disabled/deactivated
    } else if (disabled === false) {
      return "bg-[#2E9D2A] border-[15px] border-green-50"; // Green for active
    } else {
      return "bg-[#FFE500] border-[15px] border-yellow-50"; // Yellow for unknown/invited
    }
  };

  const renderStatusLabel = (disabled: boolean | undefined): string => {
    if (disabled === true) return "Deactivated";
    if (disabled === false) return "Active";
    return "Unknown";
  };

  const StatusIndicator = ({
    status,
    userId,
  }: {
    status: boolean | undefined;
    userId?: string;
  }) => {
    // status here represents the disabled boolean value
    const disabled = status;

    return (
      <div className="relative group">
        <div
          className={`${getStatusColor(disabled)} h-10 w-10 rounded-full`}
        ></div>
        <div className="absolute left-4 -top-4 hidden group-hover:block bg-[#FAFAFA] text-[#696969] shadow-lg text-xs py-1 px-2 rounded-lg whitespace-nowrap z-10">
          {renderStatusLabel(disabled)}
        </div>
      </div>
    );
  };
  // Handle navigation state for pre-filtering
  useEffect(() => {
    const prefilter = location.state?.prefilter;

    if (prefilter) {
      // Set active tab from navigation state
      if (
        prefilter.activeTab &&
        (prefilter.activeTab === "customer" || prefilter.activeTab === "expert")
      ) {
        setActiveTab(prefilter.activeTab);
      }

      // Store the prefilter data to apply after data is loaded
      if (prefilter.organizationId && prefilter.organizationName) {
        const orgFilter = {
          organization: prefilter.organizationId,
          organizationName: prefilter.organizationName,
          isPrefilter: true, // Flag to identify this as a prefilter
        };

        // Apply the filter through handleFilter
        setAppliedFilters(orgFilter);
      }

      // Clear the navigation state to prevent re-application on re-renders
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  // Apply prefilter when data is loaded and activeTab matches
  useEffect(() => {
    if (appliedFilters?.isPrefilter) {
      const currentData = activeTab === "customer" ? customers : experts;

      // Only apply if we have data
      if (currentData.length > 0) {
        console.log("Applying prefilter with data:", appliedFilters);
        handleFilter(appliedFilters);
      }
    }
  }, [customers, experts, activeTab, appliedFilters]);

  useEffect(() => {
    try {
      const countryList = csc.getCountries();
      console.log("Country data structure:", countryList);
      // Ensure countryList is an array and has the expected structure
      if (Array.isArray(countryList)) {
        setCountries(countryList);
      } else {
        console.warn("Countries data is not in expected format:", countryList);
        setCountries([]);
      }
    } catch (error) {
      console.error("Error loading countries:", error);
      setCountries([]);
    }
  }, []);

  // Handle state loading when formData.country changes
  useEffect(() => {
    if (formData.country) {
      try {
        const selectedCountry = csc.getCountryByShort(formData.country);
        const statesData = selectedCountry?.states || {};

        let statesList: string[] = [];

        // Handle different data formats from the library
        if (Array.isArray(statesData)) {
          statesList = statesData;
        } else if (typeof statesData === "object" && statesData !== null) {
          statesList = Object.keys(statesData);
        } else {
          console.warn(
            "States data is neither array nor object for country:",
            formData.country,
            statesData
          );
          statesList = [];
        }

        setStates(statesList);
        console.log(
          "States loaded for country",
          formData.country,
          ":",
          statesList.length,
          "states"
        );
      } catch (error) {
        console.error(
          "Error loading states for country:",
          formData.country,
          error
        );
        setStates([]);
      }
    } else {
      setStates([]);
    }
  }, [formData.country]);

  const handleSearch = (value: string) => {
    setSearchQuery(value);
    setCurrentPage(1); // Reset to first page when searching

    // Get current data based on active tab
    const currentData = activeTab === "customer" ? customers : experts;

    if (value.trim() === "") {
      setFilteredUsers(currentData);
    } else {
      const filtered = currentData.filter(
        (user: any) =>
          user.name?.toLowerCase().includes(value.toLowerCase()) ||
          user.email?.toLowerCase().includes(value.toLowerCase()) ||
          organizations[user.orgId]?.name
            ?.toLowerCase()
            .includes(value.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  };
  const handleFilter = (filters: any) => {
    console.log("handleFilter called with:", filters);

    // Create a clean copy of filters without the prefilter flag
    const cleanFilters = filters ? { ...filters } : null;
    if (cleanFilters?.isPrefilter) {
      delete cleanFilters.isPrefilter;
    }

    setAppliedFilters(cleanFilters);
    setCurrentPage(1); // Reset to first page when filtering

    // Get current data based on active tab
    const currentData = activeTab === "customer" ? customers : experts;

    if (!cleanFilters || Object.keys(cleanFilters).length === 0) {
      // No filters applied, show all users (or search results)
      if (searchQuery.trim() === "") {
        setFilteredUsers(currentData);
      } else {
        handleSearch(searchQuery);
      }
      return;
    }

    let filtered = [...currentData];
    console.log("Starting with current data:", filtered.length);

    // Apply search query first
    if (searchQuery.trim() !== "") {
      filtered = filtered.filter(
        (user: any) =>
          user.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          organizations[user.orgId]?.name
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase())
      );
      console.log("After search filter:", filtered.length);
    }

    // Apply organization filter
    if (cleanFilters.organization) {
      filtered = filtered.filter(
        (user: any) => user.orgId === cleanFilters.organization
      );
      console.log("After organization filter:", filtered.length);
    } // Apply role filter
    if (cleanFilters.role) {
      filtered = filtered.filter((user: any) => {
        // Handle basic role filtering (Expert/Customer)
        if (
          cleanFilters.role === "Expert" ||
          cleanFilters.role === "Customer"
        ) {
          return user.role === cleanFilters.role;
        }
        // Handle team role filtering
        return (
          user.userData?.teamRole === cleanFilters.role ||
          user.teamRole === cleanFilters.role
        );
      });
      console.log("After role filter:", filtered.length);
    }

    // Apply wallet balance filter
    if (cleanFilters.walletRanges) {
      filtered = filtered.filter((user: any) => {
        const walletBalance = parseFloat(
          user.walletBalance?.toString().replace(/[$,]/g, "") || "0"
        );

        // Check if any range matches
        let rangeMatches = false;

        if (
          cleanFilters.walletRanges.range1 &&
          walletBalance >= 0 &&
          walletBalance <= 100
        ) {
          rangeMatches = true;
        }
        if (
          cleanFilters.walletRanges.range2 &&
          walletBalance >= 101 &&
          walletBalance <= 200
        ) {
          rangeMatches = true;
        }
        if (
          cleanFilters.walletRanges.range3 &&
          walletBalance >= 201 &&
          walletBalance <= 300
        ) {
          rangeMatches = true;
        }
        if (
          cleanFilters.walletRanges.range4 &&
          walletBalance >= 301 &&
          walletBalance <= 400
        ) {
          rangeMatches = true;
        }
        if (
          cleanFilters.walletRanges.range5 &&
          walletBalance >= 401 &&
          walletBalance <= 500
        ) {
          rangeMatches = true;
        }
        if (cleanFilters.walletRanges.range6 && walletBalance >= 501) {
          rangeMatches = true;
        }

        if (
          cleanFilters.walletRanges.custom &&
          (cleanFilters.walletRanges.customMin !== null ||
            cleanFilters.walletRanges.customMax !== null)
        ) {
          const min = cleanFilters.walletRanges.customMin || 0;
          const max = cleanFilters.walletRanges.customMax || Infinity;
          if (walletBalance >= min && walletBalance <= max) {
            rangeMatches = true;
          }
        }

        return rangeMatches;
      });
      console.log("After wallet balance filter:", filtered.length);
    }

    // Apply amount filter (total amount spent/earned)
    if (cleanFilters.amountRanges) {
      filtered = filtered.filter((user: any) => {
        const amount = parseFloat(
          user.totalAmount?.toString().replace(/[$,]/g, "") ||
            user.walletBalance?.toString().replace(/[$,]/g, "") ||
            "0"
        );

        // Check if any range matches
        let rangeMatches = false;

        if (cleanFilters.amountRanges.range1 && amount >= 0 && amount <= 100) {
          rangeMatches = true;
        }
        if (
          cleanFilters.amountRanges.range2 &&
          amount >= 101 &&
          amount <= 200
        ) {
          rangeMatches = true;
        }
        if (
          cleanFilters.amountRanges.range3 &&
          amount >= 201 &&
          amount <= 300
        ) {
          rangeMatches = true;
        }
        if (
          cleanFilters.amountRanges.range4 &&
          amount >= 301 &&
          amount <= 400
        ) {
          rangeMatches = true;
        }
        if (
          cleanFilters.amountRanges.range5 &&
          amount >= 401 &&
          amount <= 500
        ) {
          rangeMatches = true;
        }
        if (cleanFilters.amountRanges.range6 && amount >= 501) {
          rangeMatches = true;
        }

        if (
          cleanFilters.amountRanges.custom &&
          (cleanFilters.amountRanges.customMin !== null ||
            cleanFilters.amountRanges.customMax !== null)
        ) {
          const min = cleanFilters.amountRanges.customMin || 0;
          const max = cleanFilters.amountRanges.customMax || Infinity;
          if (amount >= min && amount <= max) {
            rangeMatches = true;
          }
        }

        return rangeMatches;
      });
      console.log("After amount filter:", filtered.length);
    }

    console.log("Final filtered results:", filtered.length);
    setFilteredUsers(filtered);
  }; // Initial data fetch and tab switching
  useEffect(() => {
    // Initialize real-time sync for the directory
    dispatch(initializeDirectorySync());
    setCurrentPage(1); // Reset to first page when tab changes
  }, [activeTab, dispatch]);
  // Cleanup listeners on unmount
  useEffect(() => {
    return () => {
      // Cleanup any active listeners when component unmounts
      dispatch(cleanupAllListeners());
      console.log("Cleaning up directory listeners");
    };
  }, [dispatch]); // Update filtered users when data changes or filters are applied
  useEffect(() => {
    // Get current data based on active tab
    const currentData = activeTab === "customer" ? customers : experts;

    if (appliedFilters) {
      handleFilter(appliedFilters);
    } else if (searchQuery.trim() === "") {
      setFilteredUsers(currentData);
    } else {
      handleSearch(searchQuery);
    }
  }, [customers, experts, organizations, activeTab]);

  // Fetch organizations when users are loaded
  useEffect(() => {
    const currentData = activeTab === "customer" ? customers : experts;

    if (currentData.length > 0) {
      const orgIds = currentData
        .map((user: any) => user.orgId)
        .filter((orgId: string): orgId is string => !!orgId);

      const uniqueOrgIds = [...new Set(orgIds)];

      if (uniqueOrgIds.length > 0) {
        dispatch(fetchOrganizations(uniqueOrgIds));
      }
    }
  }, [customers, experts, dispatch, activeTab]);
  // Add these new state variables and handlers for the expert edit modal
  const [viewEditeModel, setViewEditeModel] = useState(false); // Rename formData for the expert edit modal to avoid conflict with the team setup form data
  const [expertFormData, setExpertFormData] = useState({
    fullName: "",
    email: "",
    ratePerMin: "",
    // availability: true,
    role: "",
    specialities: {
      "Full-service implementations": false,
      "Account setup": false,
      "Project-oriented workflows": false,
      "Process-oriented workflows": false,
      Templates: false,
      Reporting: false,
      Admin: false,
      Security: false,
      Customisation: false,
      "Integrations & APIs": false,
      "New user onboarding": false,
      "Disaster recovery": false,
      "Dashboard setup": false,
      "Data migration": false,
      Others: false,
      "Others (Specify)": false,
    },
    otherSpecialties: "",
  });
  console.log(expertFormData, "expertFormData");
  const [customSpecialtyError, setCustomSpecialtyError] = useState<string>("");

  // Input change handler for form fields
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setExpertFormData({
      ...expertFormData,
      [name]: value,
    });
  };

  // Checkbox change handler for specialities
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setExpertFormData({
      ...expertFormData,
      specialities: {
        ...expertFormData.specialities,
        [name]: checked,
      },
    });

    // Also update the selectedMember specialities for immediate UI feedback
    if (selectedMember) {
      let updatedSpecialities = [...(selectedMember.specialities || [])];

      if (checked) {
        // Add specialty if checked and not already present
        if (!updatedSpecialities.includes(name)) {
          updatedSpecialities.push(name);
        }
      } else {
        // Remove specialty if unchecked
        updatedSpecialities = updatedSpecialities.filter(
          (spec) => spec !== name
        );
      }

      setSelectedMember({
        ...selectedMember,
        specialities: updatedSpecialities,
      });

      // Update custom specialties if this is a custom one
      if (!specialtyOptions.includes(name)) {
        if (checked) {
          setCustomSpecialties((prev) => [...prev, name]);
        } else {
          setCustomSpecialties((prev) => prev.filter((spec) => spec !== name));
        }
      }
    }
  }; // Handler to save the expert data
  const onSave = async () => {
    setIsLoadingSave(true);
    setCustomSpecialtyError("");
    try {
      if (!selectedMember?.id) {
        setIsLoadingSave(false);
        return;
      }

      // Validate required fields
      if (!expertFormData.fullName.trim()) {
        setIsLoadingSave(false);
        return;
      }

      if (!expertFormData.email.trim()) {
        setIsLoadingSave(false);
        return;
      }

      // Validate "Others (Specify)" field
      if (
        expertFormData.specialities["Others (Specify)"] &&
        !expertFormData.otherSpecialties.trim()
      ) {
        setCustomSpecialtyError(
          "Please specify your other specialties when 'Others (Specify)' is selected"
        );
        setIsLoadingSave(false);
        return;
      }

      // Prepare user data update
      const userUpdateData = {
        name: expertFormData.fullName.trim(),
        email: expertFormData.email.trim(),
        ratePerMinute: parseFloat(expertFormData.ratePerMin) || 0,
        teamRole: expertFormData.role,
        uiRole: expertFormData.role,
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "admin",
      };

      // Update users collection
      const userDocRef = doc(db, `users/${selectedMember.id}`);
      await updateDoc(userDocRef, userUpdateData);

      // Get selected specialities
      const selectedSpecialities = Object.entries(expertFormData.specialities)
        .filter(([_, checked]) => checked)
        .map(([specialty, _]) => specialty);

      // Add "Others" specification if selected and specified
      if (
        expertFormData.specialities["Others (Specify)"] &&
        expertFormData.otherSpecialties.trim()
      ) {
        const otherIndex = selectedSpecialities.indexOf("Others (Specify)");
        if (otherIndex !== -1) {
          selectedSpecialities[otherIndex] =
            expertFormData.otherSpecialties.trim();
        }
      }

      // Update profiles collection
      const profilesRef = collection(db, "profiles");
      const profileQuery = query(
        profilesRef,
        where("userId", "==", selectedMember.id)
      );
      const profileSnapshot = await getDocs(profileQuery);

      const profileUpdateData = {
        name: expertFormData.fullName.trim(),
        email: expertFormData.email.trim(),
        ratePerMinute: parseFloat(expertFormData.ratePerMin) || 0,
        specialities: selectedSpecialities,
        // availability: expertFormData.availability,
        teamRole: expertFormData.role,
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "admin",
      };

      if (!profileSnapshot.empty) {
        const profileDoc = profileSnapshot.docs[0];
        const profileRef = doc(db, "profiles", profileDoc.id);
        await updateDoc(profileRef, profileUpdateData);
        console.log("Profile updated successfully:", profileUpdateData);
      } else {
        // Create new profile if it doesn't exist
        console.log("No profile found, creating new profile...");
        const newProfileData = {
          userId: selectedMember.id,
          ...profileUpdateData,
          role: "Expert",
          createdAt: new Date().toISOString(),
          createdBy: user?.email || "admin",
        };

        // Add new profile document
        await addDoc(collection(db, "profiles"), newProfileData);
        console.log("New profile created:", newProfileData);
      }

      // Create a copy of the selectedMember with updated data for UI updates
      const updatedMember = {
        ...selectedMember,
        name: expertFormData.fullName.trim(),
        email: expertFormData.email.trim(),
        ratePerMinute: parseFloat(expertFormData.ratePerMin) || 0,
        userData: {
          ...(selectedMember.userData || {}),
          name: expertFormData.fullName.trim(),
          email: expertFormData.email.trim(),
          teamRole: expertFormData.role,
          specialities: selectedSpecialities,
          ratePerMinute: parseFloat(expertFormData.ratePerMin) || 0,
          // availability: expertFormData.availability,
          disabled: selectedMember?.userData?.disabled || false,
        },
        specialities: selectedSpecialities,
        // availability: expertFormData.availability,
        teamRole: expertFormData.role,
      };

      // Dispatch immediate user data update to Redux store for instant UI feedback
      dispatch(
        updateDataImmediately("user", {
          userId: selectedMember.id,
          userData: {
            ...userUpdateData,
            specialities: selectedSpecialities, // Include specialties in userData
          },
        })
      );

      // Dispatch immediate profile data update to Redux store
      dispatch(
        updateDataImmediately("user", {
          userId: selectedMember.id,
          profileData: {
            ...profileUpdateData,
            specialities: selectedSpecialities,
          },
        })
      );

      // Update the local state for the selected member
      setSelectedMember(updatedMember);

      // If the user is viewing the expert modal, update the viewModelSelectedMember too
      if (
        expertModalOpen &&
        viewModelSelectedMember?.id === selectedMember.id
      ) {
        setViewModelSelectedMember(updatedMember);
      }

      // Update filteredUsers to reflect changes immediately
      setFilteredUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === selectedMember.id
            ? {
                ...user,
                name: expertFormData.fullName.trim(),
                email: expertFormData.email.trim(),
                ratePerMinute: parseFloat(expertFormData.ratePerMin) || 0,
                userData: {
                  ...user.userData,
                  name: expertFormData.fullName.trim(),
                  email: expertFormData.email.trim(),
                  teamRole: expertFormData.role,
                  specialities: selectedSpecialities,
                  ratePerMinute: parseFloat(expertFormData.ratePerMin) || 0,
                  // availability: expertFormData.availability,
                },
                specialities: selectedSpecialities,
                // availability: expertFormData.availability,
                teamRole: expertFormData.role,
              }
            : user
        )
      );

      // Log activity
      if (user) {
        dispatch(
          logActivity({
            userId: selectedMember.id,
            type: "Expert Profile Update",
            metadata: {
              details: "Expert profile updated by admin",
              updatedFields: {
                name: expertFormData.fullName,
                email: expertFormData.email,
                ratePerMinute: expertFormData.ratePerMin,
                role: expertFormData.role,
                specialities: selectedSpecialities,
                // availability: expertFormData.availability,
              },
              adminEmail: user.email,
              timestamp: new Date().toISOString(),
            },
          })
        );
      }

      closeExpertEditModal();
    } catch (error) {
      console.error("Failed to update expert profile:", error);
    } finally {
      setIsLoadingSave(false);
    }
  };
  const handleEdit = async (data: any) => {
    closeAllModals(); // Close any open modals first

    // Set the selected edit user ID to highlight the row
    setSelectedEditUserId(data.id);

    if (activeTab === "expert") {
      // Fetch additional profile data for experts
      let profileSpecialities = [];
      let profileRate = data.ratePerMinute?.toString().replace("$", "") || "";

      try {
        const profilesRef = collection(db, "profiles");
        const profileQuery = query(profilesRef, where("userId", "==", data.id));
        const profileSnapshot = await getDocs(profileQuery);

        if (!profileSnapshot.empty) {
          const profileDoc = profileSnapshot.docs[0];
          const profileData = profileDoc.data();
          profileSpecialities = profileData.specialities || [];
          profileRate = profileData.ratePerMinute?.toString() || profileRate;
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }

      // If no specialties in profile data, check userData
      if (profileSpecialities.length === 0 && data.specialities) {
        profileSpecialities = data.specialities;
      } else if (
        profileSpecialities.length === 0 &&
        data.userData?.specialities
      ) {
        profileSpecialities = data.userData.specialities;
      }

      setViewEditeModel(true);
      setSelectedMember({
        ...data,
        specialities: profileSpecialities,
        orgId: data.orgId || data.userData?.orgId, // Ensure orgId is included
        userData: {
          ...data.userData,
          disabled: data.userData?.disabled || false, // Ensure disabled status is included
        },
      });

      // Create specialities object with proper mapping
      const specialitiesMap = specialtyOptions.reduce((acc: any, specialty) => {
        acc[specialty] = profileSpecialities.includes(specialty) || false;
        return acc;
      }, {} as any);

      // Add custom specialties to the map
      const customSpecs = profileSpecialities.filter(
        (spec: string) => !specialtyOptions.includes(spec)
      );
      customSpecs.forEach((customSpec: string) => {
        specialitiesMap[customSpec] = true;
      });

      // Handle "Others" specialty if it exists in profile data
      const othersSpecialty = profileSpecialities.find(
        (spec: string) =>
          spec.startsWith("Others:") || spec === "Others (Specify)"
      );

      if (othersSpecialty) {
        specialitiesMap["Others (Specify)"] = true;
      }

      setExpertFormData({
        fullName: data.name || "",
        email: data.email || "",
        ratePerMin: profileRate,
        role:
          data.userData?.teamRole ||
          data.teamRole ||
          data.role ||
          "expert_team_lead",
        specialities: specialitiesMap,
        otherSpecialties:
          othersSpecialty && othersSpecialty.startsWith("Others:")
            ? othersSpecialty.replace("Others: ", "")
            : "",
      });
    } else {
      setEditOpen(true);
      setViewData({
        ...data,
        id: data.id,
        name: data.name || "",
        email: data.email || "",
        teamRole: data.userData?.teamRole || data.role || "",
        ratePerMinute: data.ratePerMinute || "",
        specialities: data.userData?.specialities || data.specialities || [],
        profileImage: data.profileImage,
        userData: {
          ...data.userData,
          disabled: data.userData?.disabled || false, // Ensure disabled status is included
        },
        orgId: data.orgId || data.userData?.orgId, // Ensure orgId is included
      });
      setSelectedMember({
        ...data,
        id: data.id,
        name: data.name || "",
        email: data.email || "",
        teamRole: data.userData?.teamRole || data.role || "",
        ratePerMinute: data.ratePerMinute || "",
        specialities: data.userData?.specialities || data.specialities || [],
        profileImage: data.profileImage,
        userData: {
          ...data.userData,
          disabled: data.userData?.disabled || false, // Ensure disabled status is included
        },
        orgId: data.orgId || data.userData?.orgId, // Ensure orgId is included
      }); 
    }
  };
  const handleView = async (data: any) => {
    closeAllModals(); // Close any open modals first

    // Set the selected user ID to highlight the row
    setSelectedUserId(data.id);

    if (activeTab === "expert") {
      // For experts, fetch specialties from profile if available
      let specialties = [];
      try {
        const profilesRef = collection(db, "profiles");
        const profileQuery = query(profilesRef, where("userId", "==", data.id));
        const profileSnapshot = await getDocs(profileQuery);

        if (!profileSnapshot.empty) {
          const profileDoc = profileSnapshot.docs[0];
          const profileData = profileDoc.data();
          specialties = profileData.specialities || [];
        }
      } catch (error) {
        console.error("Error fetching expert specialties:", error);
      }

      // Create enriched member data with specialties
      const enrichedMemberData = {
        ...data,
        // availability: availability,
        specialities:
          specialties.length > 0 ? specialties : data.specialities || [],
        userData: {
          ...(data.userData || {}),
          specialities:
            specialties.length > 0
              ? specialties
              : data.userData?.specialities || [],
        },
      };

      setSelectedMember(enrichedMemberData);
      setViewModelSelectedMember(enrichedMemberData);

      // Fetch ratings for expert
      dispatch(fetchUserRatingAndReviews({ userId: data.id, role: "Expert" }));

      setExpertModalOpen(true);
    } else {
      setProfileData(data);
      setViewModelSelectedMember(data);

      // Fetch ratings for customer
      dispatch(
        fetchUserRatingAndReviews({ userId: data.id, role: "Customer" })
      );

      setProfileViewModel(true);
      // Set profile data for the profile view model
      setViewData({
        ...data,
        orgId: data.orgId, // Ensure orgId is included
        avgRating:
          data.ratings && data.ratings.length > 0
            ? (
                data.ratings.reduce((a: number, b: number) => a + b, 0) /
                data.ratings.length
              ).toFixed(1)
            : "0.0",
        totalRatings: data.ratings?.length || 0,
        walletBalance: "0.00",
        customertotalAmount: 0,
        expertTotalEarnings: 0,
        lastActivityFull: data.lastActivityFull || "No activity",
        lastActivity: data.lastActivity || "0",
      });
    }
  }; // Enhanced close functions for each modal
  const closeProfileModal = () => {
    setProfileViewModel(false);
    setSelectedMember(null);
    setProfileData(null);
    setViewData({});
    setSelectedUserId(null); // Clear selection when modal closes
  };

  const closeEditModal = () => {
    setEditOpen(false);
    setViewData({});
    setSelectedMember(null);
    setSelectedEditUserId(null); // Clear selection when modal closes
  };
  const closeExpertEditModal = () => {
    setViewEditeModel(false);
    setSelectedMember(null);
    setSelectedEditUserId(null); // Clear selection when modal closes
    setExpertFormData({
      fullName: "",
      email: "",
      ratePerMin: "",
      // availability: true,
      role: "expert_team_lead",
      specialities: {
        "Full-service implementations": false,
        "Account setup": false,
        "Project-oriented workflows": false,
        "Process-oriented workflows": false,
        Templates: false,
        Reporting: false,
        Admin: false,
        Security: false,
        Customisation: false,
        "Integrations & APIs": false,
        "New user onboarding": false,
        "Disaster recovery": false,
        "Dashboard setup": false,
        "Data migration": false,

        "Others (Specify)": false,
      },
      otherSpecialties: "",
    });
  };

  const closeExpertModal = () => {
    setExpertModalOpen(false);
    setSelectedMember(null);
  };

  const closeSetupTeamModal = () => {
    setSetupTeamModel(false);
    setFormData({
      orgName: "",
      orgUrl: "",
      orgId: "",
      teamName: "",
      taxId: "",
      addressLine1: "",
      addressLine2: "",
      country: "",
      state: "",
      city: "",
      zipCode: "",
    });
    setStates([]);
  }; // Close all modals function
  const closeAllModals = () => {
    setProfileViewModel(false);
    setExpertModalOpen(false);
    setEditOpen(false);
    setViewEditeModel(false);
    setSetupTeamModel(false);
    setSelectedMember(null);
    setProfileData(null);
    setViewData({});
    setSelectedUserId(null); // Clear view selection
    setSelectedEditUserId(null); // Clear edit selection
    // Reset expert form data
    setExpertFormData({
      fullName: "",
      email: "",
      ratePerMin: "",
      // availability: true,
      role: "expert_team_lead",
      specialities: {
        "Full-service implementations": false,
        "Account setup": false,
        "Project-oriented workflows": false,
        "Process-oriented workflows": false,
        Templates: false,
        Reporting: false,
        Admin: false,
        Security: false,
        Customisation: false,
        "Integrations & APIs": false,
        "New user onboarding": false,
        "Disaster recovery": false,
        "Dashboard setup": false,
        "Data migration": false,

        "Others (Specify)": false,
      },
      otherSpecialties: "",
    });
    // Reset team setup form data
    setFormData({
      orgName: "",
      orgUrl: "",
      teamName: "",
      orgId: "",
      taxId: "",
      addressLine1: "",
      addressLine2: "",
      country: "",
      state: "",
      city: "",
      zipCode: "",
    });
    setStates([]); // Reset states when closing all modals
  };

  // Handle escape key to close modals
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        if (profileViewModel) {
          closeProfileModal();
        } else if (isEditOpen) {
          closeEditModal();
        } else if (viewEditeModel) {
          closeExpertEditModal();
        } else if (expertModalOpen) {
          closeExpertModal();
        } else if (setupTeamModel) {
          closeSetupTeamModal();
        }
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [
    profileViewModel,
    isEditOpen,
    viewEditeModel,
    expertModalOpen,
    setupTeamModel,
  ]);

  const onClose = () => {
    closeProfileModal();
  };

  // Format users data for the DataTable
  const formatUsersForTable = (users: any[]) => {
    return users.map((user) => ({
      id: user.id,
      name: user.name,
      email: user.email,
      organizationName: user.orgId ? organizations[user.orgId]?.name || "" : "",

      orgBilingAddress: user.orgId
        ? organizations[user.orgId]?.billingAddress || ""
        : "",
      orgId: user.orgId || "",
      url: user.url,
      role: user.role || "",
      ratePerMinute: user.ratePerMinute || 0,
      totalSessions: user.totalSessions || 0,
      lastActivity: user.lastActivity || "No activity",
      lastActivityFull: user.lastActivityFull || "No activity",
      walletBalance: user.walletBalance || 0,
      customertotalAmount: user.customerTotalAmount || 0,
      expertTotalEarnings: user.expertTotalEarnings || 0,
      amount: `${(user.walletBalance || 0).toFixed(2)}`,
      avgRating:
        user.ratings && user.ratings.length > 0
          ? (
              user.ratings.reduce((a: number, b: number) => a + b, 0) /
              user.ratings.length
            ).toFixed(1)
          : "0.0",
      totalRatings: user.ratings?.length || 0,
      userData: user.userData || user, // Ensure userData is always present
      profileImage: user.profileImageUrl,
    }));
  };
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files || !selectedMember.id ) return;

    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploadingImage(true);

      // Create storage reference
      const storageRef = ref(storage, `profileImages/${selectedMember.id }`);

      // Upload the file
      await uploadBytes(storageRef, file);

      // Get the download URL
      const imageUrl = await getDownloadURL(storageRef);

      // Update Firestore with the new image URL in users collection
      await updateDoc(doc(db, `users/${selectedMember.id}`), {
        profileImageUrl: imageUrl,
      });

      // Also update the profileImageUrl in the profiles collection (query by userId)
      const profilesRef = collection(db, "profiles");
      const profileQuery = query(profilesRef, where("userId", "==", selectedMember.id));
      const profileSnapshot = await getDocs(profileQuery);
      if (!profileSnapshot.empty) {
        const profileDoc = profileSnapshot.docs[0];
        const profileRef = doc(db, "profiles", profileDoc.id);
        await updateDoc(profileRef, {
          profileImageUrl: imageUrl,
        });
      }

      // Update local viewData state
      setViewData((prevData) => ({
        ...prevData,
        profileImage: imageUrl,
      }));

      // Dispatch immediate user data update to Redux store
      dispatch(
        updateDataImmediately("user", {
          userId: selectedMember.id,
          
            profileImage: imageUrl,
        
        })
      );

      // Log activity
      if (user) {
        dispatch(
          logActivity({
            userId: selectedMember.id,
            type: "Profile Image Update",
            metadata: { details: "Profile image updated by admin" },
          })
        );
      }
    } catch (error) {
      console.error("Failed to upload profile image:", error);
    } finally {
      setUploadingImage(false);
    }
  };
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;

    // Check if it's formData related
    if (Object.keys(formData).includes(name)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      // Handle state loading when country changes
      if (name === "country" && value) {
        try {
          const selectedCountry = csc.getCountryByShort(value);
          const statesData = selectedCountry?.states || {};

          let statesList: string[] = [];

          // Handle different data formats from the library
          if (Array.isArray(statesData)) {
            statesList = statesData;
          } else if (typeof statesData === "object" && statesData !== null) {
            statesList = Object.keys(statesData);
          } else {
            console.warn(
              "States data is neither array nor object for country:",
              value,
              statesData
            );
            statesList = [];
          }

          setStates(statesList);

          // Reset the state field when country changes
          setFormData((prev) => ({
            ...prev,
            state: "",
          }));
        } catch (error) {
          console.error("Error loading states for country:", value, error);
          setStates([]);
        }
      } else if (name === "country" && !value) {
        // Clear states when no country is selected
        setStates([]);
        setFormData((prev) => ({
          ...prev,
          state: "",
        }));
      }
    } else {
      // For teamRole, update both userData.teamRole and teamRole
      if (name === "teamRole") {
        setViewData((prev) => ({
          ...prev,
          teamRole: value,
          userData: {
            ...prev.userData,
            teamRole: value,
          },
        }));
      } else {
        // Original handleChange for viewData
        setViewData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };

  const formattedUsersData = formatUsersForTable(filteredUsers || []);
  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = formattedUsersData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  console.log(currentItems, "currentItems");
  const totalPages = Math.ceil(formattedUsersData.length / itemsPerPage);
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };
  const saveChanges = async () => {
    if (!viewData.id) {
      return;
    }

    setIsLoadingSave(true);

    try {
      // Prepare base update data
      const baseUpdateData = {
        name: viewData.name || "",
        email: viewData.email || "",
        teamRole: viewData.teamRole || viewData.userData?.teamRole || "",
        uiRole: viewData.teamRole || viewData.userData?.teamRole || "",
      };

      // For experts, include additional fields
      const expertUpdateData = {
        ...baseUpdateData,
        ratePerMinute: viewData.ratePerMinute
          ? parseFloat(viewData.ratePerMinute.toString().replace("$", ""))
          : 0,
        specialities: viewData.specialities || [],
      };

      const finalData =
        activeTab === "expert" ? expertUpdateData : baseUpdateData;

      // Update users collection
      const userDocRef = doc(db, `users/${viewData.id}`);
      await updateDoc(userDocRef, finalData);

      // Update profiles collection (by userId)
      try {
        const profilesRef = collection(db, "profiles");
        const profileQuery = query(
          profilesRef,
          where("userId", "==", viewData.id)
        );
        const profileSnapshot = await getDocs(profileQuery);

        const profileUpdateData: any = {
          name: viewData.name || "",
          email: viewData.email || "",
          teamRole: viewData.teamRole || viewData.userData?.teamRole || "",
          uiRole: viewData.userData?.teamRole || "",
          // availability:
          //   viewData.availability !== undefined
          //     ? viewData.availability
          //     : profileAvailability[viewData.id] !== undefined
          //     ? profileAvailability[viewData.id]
          //     : true,
          updatedAt: new Date().toISOString(),
          updatedBy: user?.email || "admin",
        };

        if (activeTab === "expert") {
          profileUpdateData.ratePerMinute = viewData.ratePerMinute
            ? parseFloat(viewData.ratePerMinute.toString().replace("$", ""))
            : 0;
          profileUpdateData.specialities = viewData.specialities || [];
        }

        if (!profileSnapshot.empty) {
          const profileDoc = profileSnapshot.docs[0];
          const profileRef = doc(db, "profiles", profileDoc.id);
          await updateDoc(profileRef, profileUpdateData);
        } else {
          // Create new profile if not found
          const newProfileData = {
            userId: viewData.id,
            ...profileUpdateData,
            role: activeTab === "expert" ? "Expert" : "Customer",
            createdAt: new Date().toISOString(),
            createdBy: user?.email || "admin",
          };
          await addDoc(collection(db, "profiles"), newProfileData);
        }
      } catch (profileError) {
        console.error("Failed to update profile data:", profileError);
        // Don't throw the error, just log it and continue
      }

      // Dispatch immediate user data update to Redux store
      dispatch(
        updateDataImmediately("user", {
          userId: viewData.id,
          userData: finalData,
        })
      );

      // Dispatch immediate profile data update to Redux store
      if (activeTab === "expert") {
        dispatch(
          updateDataImmediately("user", {
            userId: viewData.id,
            profileData: {
              ratePerMinute: finalData.ratePerMinute,
              specialities: finalData.specialities,
              // availability: profileUpdateData.availability,
              teamRole: finalData.teamRole,
              name: finalData.name,
              email: finalData.email,
            },
          })
        );
      } else {
        dispatch(
          updateDataImmediately("user", {
            userId: viewData.id,
            profileData: {
              teamRole: finalData.teamRole,
              name: finalData.name,
              email: finalData.email,
              // availability: profileUpdateData.availability,
            },
          })
        );
      }

      // Log activity
      if (user) {
        dispatch(
          logActivity({
            userId: viewData.id,
            type: "Profile Update",
            metadata: {
              details: `${activeTab} profile updated by admin`,
              updatedFields: Object.keys(finalData),
            },
          })
        );
      }

      // Close modal on successful save
      closeEditModal();
    } catch (error) {
      console.error("Failed to update profile:", error);
      // Optionally show error message to user here
    } finally {
      setIsLoadingSave(false);
      setEditOpen(false);
    }
  };
  const handleEditeOrgData = async () => {
    closeAllModals(); // Close any open modals first

    // Enhanced organization data retrieval
    let orgId = null;

    // Get orgId from multiple possible sources
    if (selectedMember?.orgId) {
      orgId = selectedMember.orgId;
    } else if (profileData?.orgId) {
      orgId = profileData.orgId;
    } else if (viewData?.orgId) {
      orgId = viewData.orgId;
    } else if (viewModelSelectedMember?.orgId) {
      orgId = viewModelSelectedMember.orgId;
    }

    console.log("handleEditeOrgData - orgId sources:");
    console.log("- selectedMember:", selectedMember);
    console.log("- profileData:", profileData);
    console.log("- viewData:", viewData);
    console.log("- viewModelSelectedMember:", viewModelSelectedMember);
    console.log("- Final orgId:", orgId);

    if (orgId && organizations[orgId]) {
      const orgData = organizations[orgId];
      const billingAddress = orgData.billingAddress || {};

      console.log("Found organization data:", orgData);

      // Populate form with organization data
      setFormData({
        orgName: orgData.name || "",
        orgUrl: orgData.url || "",
        teamName: orgData.teamName || "",
        taxId: orgData.taxId || "", // <-- Use actual taxId from orgData
        addressLine1: billingAddress.address_1 || "",
        addressLine2: billingAddress.address_2 || "",
        country: billingAddress.country || "",
        state: billingAddress.state || "",
        city: billingAddress.city || "",
        zipCode: billingAddress.postcode || "",
        orgId: orgId, // Add orgId to formData for reference
      });

      // ...existing code for country/state logic...
    } else {
      console.log("No organization data found, setting minimal form data");
      // Reset form but keep the orgId if we have it
      setFormData({
        orgName: "",
        orgUrl: "",
        teamName: "",
        taxId: "", // <-- Reset taxId
        addressLine1: "",
        addressLine2: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
        orgId: orgId || "", // Add orgId to formData for reference
      });
    }

    setSetupTeamModel(true);
  };
  const handleClose = () => {
    closeSetupTeamModal();
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate required fields
    let hasError = false;
    if (!formData.orgName.trim()) {
      setOrgNameError("Organization Name is required");
      hasError = true;
    } else {
      setOrgNameError("");
    }
    if (!formData.teamName.trim()) {
      setTeamNameError("Team Name is required");
      hasError = true;
    } else {
      setTeamNameError("");
    }
    if (hasError) {
      return;
    }

    setIsLoadingSave(true);

    try {
      // Enhanced logic to get organization ID from multiple sources
      let orgId = null;

      // First, try to get orgId from the currently selected/viewed member
      if (selectedMember?.orgId) {
        orgId = selectedMember.orgId;
      } else if (profileData?.orgId) {
        orgId = profileData.orgId;
      } else if (viewData?.orgId) {
        orgId = viewData.orgId;
      } else if (viewModelSelectedMember?.orgId) {
        orgId = viewModelSelectedMember.orgId;
      }

      // Last resort: check if we have any organization data loaded that matches the org name
      if (!orgId && formData.orgName.trim()) {
        const matchingOrg = Object.entries(organizations).find(
          ([_, org]) => org.name === formData.orgName.trim()
        );
        if (matchingOrg) {
          orgId = matchingOrg[0];
        }
      }

      console.log("Organization ID resolution:");
      console.log("- selectedMember?.orgId:", selectedMember?.orgId);
      console.log("- profileData?.orgId:", profileData?.orgId);
      console.log("- viewData?.orgId:", viewData?.orgId);
      console.log(
        "- viewModelSelectedMember?.orgId:",
        viewModelSelectedMember?.orgId
      );
      console.log("- formData.taxId:", formData.taxId);
      console.log("- Final orgId:", orgId);

      if (!orgId) {
        setIsLoadingSave(false);
        return;
      }

      // Prepare update data for organization
      const orgUpdateData = {
        name: formData.orgName.trim(),
        url: formData.orgUrl.trim() || "",
        teamName: formData.teamName.trim() || "",
        taxId: formData.taxId.trim() || "", // <-- Save taxId
        billingAddress: {
          address_1: formData.addressLine1.trim() || "",
          address_2: formData.addressLine2.trim() || "",
          country: formData.country || "",
          state: formData.state || "",
          city: formData.city.trim() || "",
          postcode: formData.zipCode.trim() || "",
        },
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "admin",
      };

      console.log("Updating organization with data:", orgUpdateData);

      // Update organization in Firestore
      const orgDocRef = doc(db, `organizations/${orgId}`);
      await updateDoc(orgDocRef, orgUpdateData);

      // Dispatch immediate organization data update to Redux store
      dispatch(
        updateDataImmediately("organization", {
          orgId: orgId,
          orgData: orgUpdateData,
        })
      );

      // Log activity if user exists
      if (user) {
        dispatch(
          logActivity({
            userId: user.id || orgId,
            type: "Organization Update",
            metadata: {
              details: "Organization data updated by admin",
              orgName: formData.orgName,
              orgId: orgId,
              updatedBy: user.email,
              timestamp: new Date().toISOString(),
            },
          })
        );
      }

      closeSetupTeamModal();
    } catch (error: any) {
      console.error("Failed to update organization:", error);
      const errorMessage =
        error?.message || "Failed to update organization. Please try again.";
    } finally {
      setIsLoadingSave(false);
    }
  };

  // Update user account status using disableUser or enableUser Firebase Function
  const updateUserAccountStatus = async (uid: string, disabled: boolean) => {
    try {
      const endpoint = disabled
        ? `https://us-central1-supporty-staging.cloudfunctions.net/disableUser/${uid}`
        : `https://us-central1-supporty-staging.cloudfunctions.net/enableUser/${uid}`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to update user status");
      }

      // Store the account status in the user collection
      const userDocRef = doc(db, `users/${uid}`);
      await updateDoc(userDocRef, {
        disabled: disabled,
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "admin",
      });

      return await response.json();
    } catch (error) {
      console.error("Error updating user account status:", error);
      throw error;
    }
  };
  console.log("viewData", viewData);
  const handleAccountStatusToggle = async (id: string, status: any) => {
    if (!id) return;
    setStatusLoading(true);
    try {
      // Determine the current disabled status from viewData or accountStatus
      const currentDisabled = status;
      console.log("currentDisabled:", currentDisabled);

      const newDisabled = !currentDisabled;
      console.log("newDisabled:", newDisabled);

      // Call Firebase function to disable/enable user account
      await updateUserAccountStatus(id, newDisabled);

      // Update local viewData state
      setViewData((prevData) => ({
        ...prevData,
        userData: {
          ...prevData.userData,
          disabled: newDisabled,
        },
      }));

      // Update selectedMember state if it exists (for expert edit modal)
      if (selectedMember && selectedMember.id === id) {
        setSelectedMember((prevMember) => ({
          ...prevMember,
          userData: {
            ...prevMember.userData,
            disabled: newDisabled,
          },
        }));
      }

      // Update filteredUsers to reflect changes immediately in the table
      setFilteredUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === id
            ? {
                ...user,
                userData: {
                  ...user.userData,
                  disabled: newDisabled,
                },
              }
            : user
        )
      );

      // Dispatch immediate user data update to Redux store
      dispatch(
        updateDataImmediately("user", {
          userId: id,
          userData: {
            disabled: newDisabled,
          },
        })
      );

      // Log activity
      if (user) {
        dispatch(
          logActivity({
            userId: id,
            type: "Account Status Update",
            metadata: {
              details: `Account ${
                newDisabled ? "disabled" : "enabled"
              } by admin`,
              newStatus: newDisabled ? "disabled" : "enabled",
              adminEmail: user.email,
              timestamp: new Date().toISOString(),
            },
          })
        );
      }
    } catch (error) {
      console.error("Failed to update account status", error);
    } finally {
      setStatusLoading(false);
    }
  };

  const [accountStatus, setAccountStatus] = useState<any | null>(null); // fetched status
  const [statusLoading, setStatusLoading] = useState(false);

  useEffect(() => {
    if (
      selectedMember?.specialities &&
      Array.isArray(selectedMember.specialities)
    ) {
      // Filter out predefined specialties to get only custom ones
      const userCustomSpecialties = selectedMember.specialities.filter(
        (specialty) => !specialtyOptions.includes(specialty)
      );
      setCustomSpecialties(userCustomSpecialties);

      // Update expertFormData to include custom specialties
      if (userCustomSpecialties.length > 0) {
        const updatedSpecialities = { ...expertFormData.specialities };
        userCustomSpecialties.forEach((customSpecialty) => {
          updatedSpecialities[customSpecialty] = true;
        });
        setExpertFormData((prev) => ({
          ...prev,
          specialities: updatedSpecialities,
        }));
      }
    }
  }, [selectedMember?.specialities]);

  const mergedSpecialties = [
    ...specialtyOptions.filter((s) => s !== "Others (Specify)"),
    ...customSpecialties,
    "Others (Specify)", // Add "Others (Specify)" at the end
  ];
  console.log(currentItems, "currentItems");
  console.log(accountStatus, "Account Status");
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState<any | null>(null);
  return (
    <Layout>
      <div
        className="p-6 mx-auto bg-white rounded-lg shadow-sm"
        style={{
          height: "calc(100vh - 112px)",
          overflowY: "hidden",
            overflowX:'hidden'
        }}
      >
        {" "}
        <TabGroup
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />{" "}
        <SearchHeader
          title="Directory"
          onSearch={handleSearch}
          onFilter={handleFilter}
          adminDirectory={true}
          organizations={Object.values(organizations)}
          activeTab={activeTab}
          hasPreFilter={!!appliedFilters}
          appliedFilters={appliedFilters} // Pass appliedFilters to SearchHeader
        />{" "}
        {(customersLoading && activeTab === "customer") ||
        (expertsLoading && activeTab === "expert") ? (
          <div className="flex justify-center items-center py-8">
            <Loader className="animate-spin text-orange-500" size={32} />
          </div>
        ) : (customersError && activeTab === "customer") ||
          (expertsError && activeTab === "expert") ? (
          <div className="text-red-500 text-center py-8">
            Error: {activeTab === "customer" ? customersError : expertsError}
          </div>
        ) : (
          <div
            className="bg-white rounded-[12px] border-[1px]  border-[#EBEBEB] overflow-hidden overflow-x-auto"
           style={{
          height: "calc(80vh - 150px)",
          overflowY: "auto",
            overflowX:'hidden'
        }}>
            <table className="min-w-full divide-y max-h-[700px] divide-gray-200">
              <thead className="bg-[#FEF0EA]">
                <tr>
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Status
                  </th>
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Name
                  </th>
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Organization Name
                  </th>
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Role
                  </th>
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Email
                  </th>
                  {activeTab === "expert" && (
                    <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                      Rate/Min
                    </th>
                  )}
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Total Sessions
                  </th>
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Last Activity
                  </th>{" "}
                  {activeTab === "expert" && (
                    <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                      Total Earnings
                    </th>
                  )}
                  {activeTab === "customer" && (
                    <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                      Wallet
                    </th>
                  )}{" "}
                  {activeTab === "customer" && (
                    <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                      Total Amount
                    </th>
                  )}
                  <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {" "}
                {currentItems.length > 0 ? (
                  currentItems.map((user) => {
                    // Only highlight if the modal is open and the selected user matches
                    const isSelected =
                      profileViewModel && selectedUserId === user.id;
                    const isEditSelected =
                      isEditOpen && selectedEditUserId === user.id;
                    const experttabview =
                      expertModalOpen && selectedMember?.id === user.id;
                    const expertEditeModel =
                      viewEditeModel && selectedEditUserId === user.id;

                    const shouldHighlight =
                      isSelected ||
                      isEditSelected ||
                      experttabview ||
                      expertEditeModel;

                    return (
                      <tr
                        key={user.id}
                        className={shouldHighlight ? "bg-gray-100" : "bg-white"}
                      >
                        {" "}
                        <td className="px-2 py-3 whitespace-nowrap">
                          <div className="flex items-center justify-center">
                            <StatusIndicator
                              status={user.userData?.disabled}
                              userId={user.id}
                            />
                          </div>
                        </td>
                        <td className="px-2 py-3 whitespace-nowrap">
                          <div className="flex items-center">
                            {user.profileImage ? (
                              <img
                                className="h-10 w-10 rounded-full object-cover mr-3"
                                src={user.profileImage}
                                alt="Profile Image"
                              />
                            ) : (
                              <div className="w-10 h-10 bg-[#F15D18] rounded-full flex items-center justify-center text-white font-bold mr-3">
                                {user.name
                                  ?.split(" ")
                                  .map((part: string) =>
                                    part.charAt(0).toUpperCase()
                                  )
                                  .join("")}
                              </div>
                            )}
                            <div className="text-[14px] truncate max-w-28 nunito-semibold text-[#696969]">
                              {user.name}
                            </div>
                          </div>
                        </td>
                        <td className="px-2 py-3 whitespace-nowrap truncate max-w-40 nunito-regular text-[14px] text-[#696969]">
                          {user.organizationName || "N/A"}
                        </td>{" "}
                        <td className="px-2 py-3 whitespace-nowrap nunito-regular text-[14px] text-[#696969]">
                          {getTeamRoleDisplay(
                            user.userData?.teamRole || user.role
                          )}
                        </td>{" "}
                        <td className="px-2 py-3 whitespace-nowrap">
                          <div className="text-[14px] nunito-regular text-[#696969] truncate w-48">
                            <span>{user.email.slice(0, 15)}</span>
                            <span>{user.email.slice(15)}</span>
                          </div>
                        </td>
                        {activeTab === "expert" && (
                          <td className="px-2 py-3 whitespace-nowrap nunito-regular text-[14px] text-[#696969]">
                            ${Number(user.ratePerMinute || 0).toFixed(2)}
                          </td>
                        )}
                        <td className="px-2 py-3 whitespace-nowrap nunito-regular text-[14px] text-[#696969]">
                          {user.totalSessions}
                        </td>{" "}
                        <td className="px-2 py-3 whitespace-nowrap nunito-regular text-[14px] text-[#696969]">
                          {user.lastActivity}
                        </td>
                        {activeTab === "expert" && (
                          <td className="px-2 py-3 whitespace-nowrap nunito-regular text-[14px] text-[#696969]">
                            ${user.expertTotalEarnings.toFixed(2) || 0}
                          </td>
                        )}
                        {activeTab === "customer" && (
                          <td className="px-2 py-3 whitespace-nowrap nunito-regular text-[14px] text-[#696969]">
                            ${user.walletBalance.toFixed(2) || 0}
                          </td>
                        )}
                        {activeTab === "customer" && (
                          <td className="px-2 py-3 whitespace-nowrap nunito-regular text-[14px] text-[#696969]">
                            ${user.customertotalAmount.toFixed(2) || 0}
                          </td>
                        )}
                        <td className="px-2 py-3 whitespace-nowrap">
                          <div className="flex items-center space-x-4">
                            <button
                              className="hover:text-gray-500"
                              onClick={() => handleEdit(user)}
                            >
                              <Pencil className="w-[20px] h-[20px] text-[#919191]" />
                            </button >
                            <div className="relative group">

                            <button
                              className="hover:text-gray-500"
                              onClick={() => {
                                setDeleteConfirmOpen(true);
                                setUserToDelete(user);
                              }}
                              disabled
                              >
                              <Trash2 className="w-[20px] h-[20px] text-[#919191]" />
                            </button>
                               <div className="absolute right-0 -top-8 px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 whitespace-nowrap z-30" dir="rtl">
            !This feature is on its way - stay tuned
          </div>
                              </div>
                            <button
                              onClick={() => handleView(user)}
                              className="text-[#F15D18] underline cursor-pointer text-[14px] nunito-semibold"
                            >
                              View
                            </button>{" "}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10}>
                      <div className="flex flex-col items-center py-20">
                        <div className="w-24 h-24 mb-4 flex items-center justify-center">
                          <Search className="w-16 h-16 text-gray-400" />
                        </div>
                        <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                          Opps! No matching records found.
                        </h2>
                        <p className="text-[#919191] text-[14px] nunito-semibold mb-4 text-center">
                          Try changing the filters or search criteria to see
                          more results!
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>{" "}
            </table>
          </div>
        )}{" "}
        {/* Pagination */}
        {currentItems?.length > 0 && totalPages > 1 && (
          <div className="py-3 flex items-center justify-center">
            <nav className="flex space-x-1">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={`px-2 py-1 text-[#696969] ${
                    currentPage === index + 1
                      ? "bg-[#FAFAFA] border-[#EBEBEB] rounded-[8px] border"
                      : ""
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>{" "}
      {/* Customer Profile View Modal */}
      {profileViewModel && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeProfileModal();
            }
          }}
        >
          <div className="bg-white rounded-[24px] w-[560px]  shadow-lg p-4">
            {" "}
            <div className="text-right">
              <button
                onClick={closeProfileModal}
                className="text-[#696969] hover:text-gray-700"
              >
                <X className="w-[32px] h-[32px] stroke-[2px]" />
              </button>
            </div>
            <div className="relative border-[1px] border-[#C4C4C4] mb-3 rounded-[16px] p-4">
              <div className="text-[20px] nunito-semibold truncate max-w-36 text-[#0A0A0A] absolute top-4 right-4">
                {/* Team 1 */}
                {organizations[viewData?.orgId]?.teamName}
              </div>
              <div className="flex items-center space-x-4 mb-6 relative">
                <div className="relative flex justify-center">
                  {profileData?.profileImage ? (
                    <img
                      src={profileData?.profileImage}
                      alt="Profile"
                      className="w-[80px] h-[80px] rounded-[16px] object-cover"
                    />
                  ) : (
                    <div className="w-[80px] h-[80px] rounded-[16px] bg-[#F15D18] flex items-center justify-center text-white text-2xl font-bold">
                      {profileData?.name
                        ?.split(" ")
                        .map((part: string) => part.charAt(0).toUpperCase())
                        .join("")}
                    </div>
                  )}{" "}
                  <span
                    className={`px-2 py-1 flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2 ${
                      profileData?.userData?.disabled || profileData?.disabled
                        ? "bg-[#FFE4E4] text-[#B71C1C]"
                        : "bg-[#CBF3C9] text-[#1B8717]"
                    }`}
                  >
                    {profileData?.userData?.disabled || profileData?.disabled
                      ? "Deactivated"
                      : "Active"}
                  </span>
                </div>
                <div className="flex-1">
                  <div className="group relative inline-block    ">
                    <span className=" text-[#0A0A0A] truncate  text-[24px] nunito-semibold ">
                     {profileData?.name?.length > 20
    ? `${profileData.name.slice(0, 20)}...`
    : profileData?.name || ""}
                    </span>
                    
                  
                    {/* Tooltip on hover */}
                    <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-7  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                      <div className="text-start">
                        <div className="nunito-regular text-[12px] text-[#696969] mb-1">
                          {profileData?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" group relative">

                  <p className="text-[#404040] truncate max-w-96 text-[14px] nunito-medium">
                    {profileData.email}
                  </p>
                     <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-5  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                                <div className="text-start">
                                  <div className="nunito-regular text-[12px]  truncate text-[#696969] mb-1">
                                                     {profileData.email}

                                  </div>
                                </div>
                              </div>
                  </div>
                    <span className=" text-[#696969] text-[14px] nunito-medium">
                      (
                      {getTeamRoleDisplay(
                        profileData?.userData?.teamRole || ""
                      )}
                      )
                    </span>{" "}

                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Star className="w-[20px] h-[20px] fill-[#F5A038] text-[#F5A038]" />
                      <span className="text-[#696969] text-[14px] nunito-regular">
                        {ratingsLoading[profileData?.id]
                          ? ""
                          : userRatings[profileData?.id]?.avgRating?.toFixed(
                              1
                            ) || "0.0"}
                      </span>
                      <span className="text-[#696969] text-[14px] nunito-regular ml-1">
                        (
                        {ratingsLoading[profileData?.id]
                          ? ""
                          : userRatings[profileData?.id]?.totalReviews ||
                            "0"}{" "}
                        reviews)
                      </span>
                    </div>
                    <div className="text-[#696969] flex items-center">
                      <Clock className="w-[14px] text-[#696969] h-[14px]" />
                      <span className="text-[14px] text-[#404040] nunito-regular ml-1">
                        {profileData?.lastActivityFull ||
                          ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 pt-2 px-">
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Total Sessions
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    {profileData.totalSessions}
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Wallet
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    ${profileData.walletBalance.toFixed(2) || "0.00"}
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Total Amount
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    ${profileData.customertotalAmount.toFixed(2) || "0.00"}
                  </p>
                </div>
              </div>{" "}
              <div className="text-right mt-2">
                <button
                  className="text-[#696969]"
                  onClick={() => handleEdit(profileData)}
                >
                  <Pencil className="h-[24px] w-[24px] text-[#696969]" />
                </button>
              </div>
            </div>
            {/* Organization section */}
            <div className="flex items-center p-4 bg-white rounded-[16px] border-[1px] border-[#C4C4C4] relative">
              {/* Logo/Icon */}
              <div className="mr-2">
                <Building2 className="w-[80px] h-[80px] stroke-[0.5px] text-[#000000]" />
              </div>
              {/* Text Content */}
              <div className="flex-grow">
                <div className="flex justify-between items-start">
                  <h2 className="text-[20px] nunito-semibold truncate max-w-36 text-[#0A0A0A]">
                    {profileData?.organizationName || "Organization"}
                  </h2>
                  <div className="flex items-center text-[#404040] text-[12px]">
                    <NotepadText className="w-[16px] h-[16px] mr-1 text-[#7B7B7B]" />
                    <span>
                      Tax ID:{" "}
                      {profileData?.organizationName
                        ? organizations[viewData?.orgId]?.taxId || "N/A"
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <div className="">
                  <p className="text-[14px] nunito-medium text-[#404040] mt-">
                    Website:{" "}
                    {profileData?.organizationName
                      ? organizations[viewData?.orgId]?.url || "N/A"
                      : "N/A"}
                  </p>
                  <p className="text-[14px] nunito-medium text-[#404040] mt-">
                    Address:{" "}
                    {profileData?.organizationName
                      ? organizations[viewModelSelectedMember?.orgId]
                          ?.billingAddress
                        ? `${
                            organizations[viewModelSelectedMember?.orgId]
                              ?.billingAddress?.address_1 || ""
                          }, ${
                            organizations[viewModelSelectedMember?.orgId]
                              ?.billingAddress?.address_2 || ""
                          }, ${
                            organizations[viewModelSelectedMember?.orgId]
                              ?.billingAddress?.city || ""
                          }, ${getStateFullName(
                            organizations[viewModelSelectedMember.orgId]
                              .billingAddress?.country || "",
                            organizations[viewModelSelectedMember.orgId]
                              .billingAddress?.state || ""
                          )}, ${getCountryFullName(
                            organizations[viewModelSelectedMember.orgId]
                              .billingAddress?.country || ""
                          )}, ${
                            organizations[viewModelSelectedMember?.orgId]
                              ?.billingAddress?.postcode || ""
                          }`
                        : "N/A"
                      : "N/A"}
                  </p>
                </div>
              </div>
              {/* <div className="absolute bottom-2 right-3">
                <button className="text-[#696969]" onClick={handleEditeOrgData}>
                  <Pencil className="h-[24px] w-[24px] text-[#696969]" />
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}{" "}
      {isEditOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeEditModal();
            }
          }}
        >
          <div className="bg-white rounded-[24px] shadow-lg w-[448px]">
            {" "}
            <div className="flex justify-between items-center px-6 py-4">
              <h2 className="text-[24px] text-[#0A0A0A] nunito-semibold">
                Edit
              </h2>
              <button
                onClick={closeEditModal}
                className="text-[#696969] hover:text-gray-700"
              >
                <X className="h-[32px] w-[32px]" />
              </button>
            </div>
            <div className="px-6">
              <div className="p-5 border-[1px] rounded-[16px] border-[#C4C4C4] mx-4">
                {" "}
                <div className="mb-6 flex justify-start">
                  <div className="relative">
                    <div className="w-[80px] h-[80px] rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                      {viewData?.profileImage ? (
                        <img
                          src={viewData.profileImage}
                          alt="Profile"
                          className="w-full h-full rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full bg-[#F15D18] rounded-full flex items-center justify-center text-white text-xl font-bold">
                          {viewData?.name
                            ?.split(" ")
                            .map((part: string) => part.charAt(0).toUpperCase())
                            .join("") || "U"}
                        </div>
                      )}
                    </div>
                    <label className="absolute bottom-0 right-0 bg-[#F15D18] text-white p-1 disabled:cursor-not-allowed rounded-full cursor-pointer">
                      <Camera className="w-4 h-4" />
                      <input
                        type="file"
                        className="hidden"
                        accept="image/*"
                        onChange={handleImageUpload}
                        disabled={uploadingImage}
                      />
                    </label>
                     {uploadingImage && (
                                                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full">
                                                    <Loader
                                                      className="animate-spin text-white"
                                                      size={24}
                                                    />
                                                  </div>
                                                )}
                  </div>
                </div>{" "}
                <div className="flex items-center mb-4">
                  {" "}
                  <h1 className="text-[20px] mr-4 text-[#404040] nunito-semibold">
                    Account Status
                  </h1>
                  <span className="font-medium mr-3">
                    {viewData?.userData?.disabled ? "Deactivated" : "Active"}
                  </span>
                  <div
                    className={`relative w-12 h-6 rounded-full ${
                      viewData?.userData?.disabled
                        ? "bg-gray-300"
                        : "bg-green-500"
                    } cursor-pointer`}
                    onClick={() =>
                      handleAccountStatusToggle(
                        viewData?.id,
                        viewData?.userData?.disabled
                      )
                    }
                    style={{ opacity: statusLoading ? 0.5 : 1 }}
                  >
                    <div
                      className={`absolute top-1 h-4 w-4 rounded-full bg-white transition-all ${
                        viewData?.userData?.disabled ? "left-1" : "left-7"
                      }`}
                    ></div>
                  </div>
                </div>
                <div className="mb-5">
                  <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                    Full Name
                  </label>

                  <input
                    type="text"
                    name="name"
                    value={viewData?.name || ""}
                    onChange={handleChange}
                    disabled={isLoadingSave}
                    className="w-full px-3 py-2 border-[1px] border-[#696969] rounded-[6px] text-[14px] nunito-normal"
                  />
                </div>{" "}
                <div className="mb-5">
                  <label className="block text-[16px] text-[#404040] nunito-semibold mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    disabled
                    value={viewData?.email || ""}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border-[1px] border-[#696969] text-[#404040] text-[14px] nunito-normal rounded-[6px]"
                  />
                </div>{" "}
                <div className="mb-5">
                  <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                    Role
                  </label>
                  <div className="relative">
                    <select
                      name="teamRole"
                      value={
                        viewData?.userData?.teamRole || viewData?.teamRole || ""
                      }
                      disabled={isLoadingSave}
                      onChange={(e) => handleChange(e as any)}
                      className="w-full px-3 py-2 border-[1px] border-[#696969] text-[#404040] text-[14px] nunito-normal rounded-[6px] appearance-none"
                    >
                      {activeTab === "customer" ? (
                        <>
                          <option value="customer_owner">Team Owner</option>
                          <option value="customer_team_lead">Team Lead</option>
                          <option value="customer_team_member">
                            Team Member
                          </option>
                        </>
                      ) : (
                        <>
                          <option value="expert_owner">Team Owner</option>
                          <option value="expert_team_lead">Team Lead</option>
                          <option value="expert_team_member">
                            Team Member
                          </option>
                        </>
                      )}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                      <svg
                        className="w-4 h-4 text-[#696969]"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 01.414 1.414l-4 4a1 1 01-1.414 0l-4-4a1 1 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-6 py-4 flex justify-center">
                <button
                  onClick={saveChanges}
                  className="bg-[#F15D18] w-[120px] h-[40px] hover:bg-orange-600 text-[16px] nunito-semibold text-white px-8 py-2 rounded-[8px] transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                >
                  {isLoadingSave ? (
                    <Loader
                      className="animate-spin text-white mx-auto"
                      size={20}
                    />
                  ) : (
                    "Save"
                  )}
                </button>
              </div>{" "}
            </div>
          </div>
        </div>
      )}{" "}
      {/*  activeTab === "expert"  */}
      {viewEditeModel && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeExpertEditModal();
            }
          }}
        >
          <div className="bg-white rounded-xl shadow-lg w-[832px] max-h-[90vh] flex flex-col overflow-y-auto p-3">
            {/* Fixed Header */}
            <div className="flex justify-between items-center mb-3 flex-shrink-0">
              <h2 className="text-[24px] nunito-semibold text-[#0A0A0A]">
                Edit - Member
              </h2>
              <button
                onClick={closeExpertEditModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 ">
              <div className="p-4 border rounded-[16px]">
                <div className="grid grid-cols-8 gap-4">
                  {/* Profile Image - Takes 1 column on the left */}
                  <div className="col-span-1 flex flex-col items-center justify-start">
                     <div className="relative">
                    <div className="w-[80px] h-[80px] rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                      {selectedMember?.profileImage ? (
                        <img
                          src={selectedMember.profileImage}
                          alt="Profile"
                          className="w-full h-full rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full bg-[#F15D18] rounded-full flex items-center justify-center text-white text-xl font-bold">
                          {expertFormData.fullName
                            ?.split(" ")
                            .map((part: string) => part.charAt(0).toUpperCase())
                            .join("") || "U"}
                        </div>
                      )}
                    </div>
                    <label className="absolute bottom-0 right-0 bg-[#F15D18] text-white p-1 disabled:cursor-not-allowed rounded-full cursor-pointer">
                      <Camera className="w-4 h-4" />
                      <input
                        type="file"
                        className="hidden"
                        accept="image/*"
                        onChange={handleImageUpload}
                        disabled={uploadingImage}
                      />
                    </label>
                     {uploadingImage && (
                                                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full">
                                                    <Loader
                                                      className="animate-spin text-white"
                                                      size={24}
                                                    />
                                                  </div>
                                                )}
                  </div>
                  </div>

                  {/* Form Content - Takes 3 columns on the right */}
                  <div className="col-span-7">
                    <div className="flex items-center mb-4">
                      <h1 className="text-[20px] mr-4 text-[#404040] nunito-semibold">
                        Account Status
                      </h1>
                      <span className="font-medium mr-3">
                        {selectedMember?.userData?.disabled
                          ? "Deactivated"
                          : "Active"}
                      </span>
                      <div
                        className={`relative w-12 h-6 rounded-full ${
                          selectedMember?.userData?.disabled
                            ? "bg-gray-300"
                            : "bg-green-500"
                        } cursor-pointer`}
                        onClick={() =>
                          handleAccountStatusToggle(
                            selectedMember?.id,
                            selectedMember?.userData?.disabled
                          )
                        }
                        style={{ opacity: statusLoading ? 0.5 : 1 }}
                      >
                        <div
                          className={`absolute top-1 h-4 w-4 rounded-full bg-white transition-all ${
                            selectedMember?.userData?.disabled
                              ? "left-1"
                              : "left-7"
                          }`}
                        ></div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-6 mb-6">
                      <div>
                        <label className="block mb-2 text-[#404040] nunito-semibold">
                          Full Name
                        </label>
                        <input
                          type="text"
                          name="fullName"
                          value={expertFormData.fullName}
                          onChange={handleInputChange}
                          disabled={isLoadingSave}
                          className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block mb-2 text-[#404040] nunito-semibold">
                          Email
                        </label>
                        <input
                          type="email"
                          disabled
                          placeholder="Email"
                          name="email"
                          value={expertFormData.email}
                          onChange={handleInputChange}
                          className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-6 mb-6">
                      <div>
                        <label className="block mb-2 text-[#404040] nunito-semibold">
                          Rate per min
                        </label>
                        <input
                          type="number"
                          name="ratePerMin"
                          value={expertFormData.ratePerMin}
                          onChange={handleInputChange}
                          disabled={isLoadingSave}
                          className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block mb-2 text-[#404040] nunito-semibold">
                          Role
                        </label>
                        <div className="relative">
                          <select
                            name="role"
                            value={expertFormData.role}
                            onChange={handleInputChange}
                            disabled={isLoadingSave}
                            className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="expert_team_lead">Team Lead</option>
                            <option value="expert_team_member">
                              Team Member
                            </option>
                            <option value="expert_owner">Team Owner</option>
                          </select>
                          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-6">
                      <h3 className="mb-4 text-[#696969] text-[20px] nunito-semibold">
                        Specialties
                      </h3>
                      <div className="grid grid-cols-3 gap-y-3">
                        {mergedSpecialties.map((specialty, index) => (
                          <div key={specialty} className="flex items-center">
                            <input
                              type="checkbox"
                              id={`specialty-${index}`}
                              name={specialty}
                              checked={
                                expertFormData.specialities[specialty] || false
                              }
                              disabled={isLoadingSave}
                              onChange={handleCheckboxChange}
                              className={`w-[16px] h-[16px] ${
                                expertFormData.specialities[specialty]
                                  ? "bg-[#F15D18] border-[#F15D18] text-white"
                                  : "border-[#D9D9D9]"
                              } rounded focus:ring-orange-500 focus:ring-offset-0 cursor-pointer appearance-none border checked:bg-orange-500 transition-colors duration-200 ease-in-out`}
                              style={{
                                backgroundImage: expertFormData.specialities[
                                  specialty
                                ]
                                  ? "url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 01.414 0z'/%3e%3c/svg%3e\")"
                                  : "",
                                backgroundSize: "100% 100%",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                              }}
                            />
                            <label
                              htmlFor={`specialty-${index}`}
                              className="ml-2 text-[14px] nunito-regular text-[#404040] nunito-regular cursor-pointer"
                            >
                              {specialty}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Only show "Others (Specify)" input field when "Others" checkbox is checked */}
                    {expertFormData.specialities["Others (Specify)"] && (
                      <>
                        <div className="mb-">
                          <label className="block mb-2 text-[#404040] text-[14px] nunito-regular">
                            Others (Specify)
                          </label>
                          <input
                            type="text"
                            name="otherSpecialties"
                            value={expertFormData.otherSpecialties}
                            onChange={(e) => {
                              handleInputChange(e);
                              setCustomSpecialtyError("");
                            }}
                            disabled={isLoadingSave}
                            placeholder="Please specify your other specialties"
                            className={`w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 ${
                              customSpecialtyError
                                ? "border-red-500 focus:ring-red-500"
                                : "border-gray-300 focus:ring-blue-500"
                            }`}
                          />
                        </div>
                        {customSpecialtyError && (
                          <div className="mb-6">
                            <span className="text-red-500 text-[13px]">
                              {customSpecialtyError}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Fixed Footer */}
            <div className="flex mt-3 justify-center flex-shrink-0">
              <button
                onClick={onSave}
                disabled={isLoadingSave}
                className="px-2 py-2 w-[120px] justify-center h-[40px] bg-[#F15D18] text-[#FFFFFF] text-[16px] nunito-semibold rounded-[8px] hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
              >
                {isLoadingSave ? (
                  <>
                    <Loader className="animate-spin mr-2" size={16} />
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {setupTeamModel && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeSetupTeamModal();
            }
          }}
        >
          <div className="bg-white rounded-2xl shadow-lg w-full  max-w-2xl p-4 px-6 relative">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-[24px] text-[#0A0A0A] nunito-semibold">
                Edit
              </h2>{" "}
              <button
                className="text-[#344054] hover:text-gray-700"
                onClick={closeSetupTeamModal}
              >
                <X className="w-[20px] h-[20px]" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="space-y-3">
                <div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                        Organization Name
                      </label>
                      <input
                        type="text"
                        name="orgName"
                        placeholder="Enter Name"
                        value={formData.orgName}
                        onChange={handleChange}
                        required
                        className={`w-full px-3 py-2 border ${
                          orgNameError ? "border-red-500" : "border-[#D7DEDD]"
                        } text-[#404040] text-[14px] nunito-normal rounded-[6px] focus:outline-none focus:ring-2 focus:ring-orange-500`}
                      />
                      {/* {orgNameError && (
                        <span className="text-red-500 text-xs mt-1 block">
                          {orgNameError}
                        </span>
                      )} */}
                    </div>
                    <div>
                      <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                        Team Name
                      </label>
                      <input
                        type="text"
                        name="teamName"
                        placeholder="Enter Team Name"
                        value={formData.teamName}
                        onChange={handleChange}
                        required
                        className={`w-full px-3 py-2 border ${
                          teamNameError ? "border-red-500" : "border-[#D7DEDD]"
                        } rounded-[6px] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500`}
                      />
                      {/* {teamNameError && (
                        <span className="text-red-500 text-xs mt-1 block">
                          {teamNameError}
                        </span>
                      )} */}
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                      Organization URL
                    </label>
                    <input
                      type="text"
                      name="orgUrl"
                      placeholder="Enter URL"
                      value={formData.orgUrl}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] nunito-normal text-[14px] focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                      Tax ID (Used for Invoicing)
                    </label>
                    <input
                      type="text"
                      name="taxId"
                      placeholder="Tax ID "
                      value={formData.taxId}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] nunito-normal text-[14px] "
                    />
                  </div>

                  <div className="mb-4">
                    <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                      Address Line 1
                    </label>
                    <input
                      type="text"
                      name="addressLine1"
                      placeholder="Enter Address"
                      value={formData.addressLine1}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                      Address Line 2
                    </label>
                    <input
                      type="text"
                      name="addressLine2"
                      placeholder="Enter Address"
                      value={formData.addressLine2}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                        Country
                      </label>
                      <div className="relative">
                        <select
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-[#D9D9D9] rounded-[8px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                        >
                          <option value="">Select country</option>
                          {Array.isArray(countries) &&
                            countries.map((country) => (
                              <option
                                key={country.shortName || country.code}
                                value={country.shortName || country.code}
                              >
                                {country.name}
                              </option>
                            ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                          <svg
                            className="w-[16px] h-[16px] text-[#696969]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div>
                      <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                        State
                      </label>
                      <div className="relative">
                        {" "}
                        <select
                          name="state"
                          // value={formData.state}
                          value={getStateFullName(
                            formData.country,
                            formData.state
                          )}
                          onChange={handleChange}
                          disabled={
                            !formData.country ||
                            !Array.isArray(states) ||
                            states.length === 0
                          }
                          className="w-full px-3 py-2 border border-[#D9D9D9] rounded-[8px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                        >
                          <option value="">
                            {!formData.country
                              ? "Select country first"
                              : "Select state"}
                          </option>
                          {Array.isArray(states) &&
                            states.map((state, index) => (
                              <option key={index} value={state}>
                                {state}
                              </option>
                            ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                          <svg
                            className="w-[16px] h-[16px] text-[#696969]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                        City
                      </label>
                      <input
                        type="text"
                        name="city"
                        placeholder="Enter City"
                        value={formData.city}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                      />
                    </div>

                    <div>
                      <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                        Zip Code
                      </label>
                      <input
                        type="text"
                        name="zipCode"
                        placeholder="Enter Zip code"
                        value={formData.zipCode}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                      />
                    </div>
                  </div>
                </div>{" "}
                <div className="flex justify-center">
                  <button
                    type="submit"
                    disabled={isLoadingSave}
                    className="px-4 py-2 w-[95px] h-[44px] bg-[#F15D18] text-white text-[18px] nunito-semibold rounded-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                    {isLoadingSave ? (
                      <Loader className="animate-spin text-white" size={16} />
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </form>{" "}
          </div>
        </div>
      )}{" "}
      {/* Expert View Modal */}
      {expertModalOpen && selectedMember && (
        <div
          className="fixed inset-0 flex items-center  justify-center bg-black bg-opacity-50 z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeExpertModal();
            }
          }}
        >
          <div className="bg-white rounded-[24px] w-[560px]  shadow-lg p-4 relative">
            {" "}
            <div className="mb-9">
              <button
                onClick={closeExpertModal}
                className="absolute top-3 right-4 hover:text-gray-700"
              >
                <X className="w-[32px] h-[32px] text-[#696969]" />
              </button>
            </div>
            <div className="border border-[#C4C4C4] mb-3 px-2 rounded-[16px] relative">
              <div className="text-[20px] nunito-semibold max-w-36 truncate text-[#0A0A0A] absolute top-4 right-4">
                {organizations[selectedMember?.userData?.orgId]?.teamName}
              </div>
              <div className="flex items-center p-3 mb-4">
                <div className="flex items-center w-full">
                  <div className="relative flex items-center justify-center mr-3">
                    {selectedMember?.profileImage ? (
                      <img
                        src={selectedMember.profileImage}
                        alt="Profile"
                        className="w-[80px] h-[80px] rounded-[16px] object-cover"
                      />
                    ) : (
                      <div className="w-[80px] h-[80px] rounded-[16px] bg-[#F15D18] flex items-center justify-center text-white text-2xl font-bold">
                        {selectedMember?.name
                          ?.split(" ")
                          .map((part: string) => part.charAt(0).toUpperCase())
                          .join("")}
                      </div>
                    )}{" "}
                    <span
                      className={`px-2 py-1 flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2 ${
                        selectedMember?.userData?.disabled ||
                        selectedMember?.disabled
                          ? "bg-[#FFE4E4] text-[#B71C1C]"
                          : "bg-[#CBF3C9] text-[#1B8717]"
                      }`}
                    >
                      {selectedMember?.userData?.disabled ||
                      selectedMember?.disabled
                        ? "Deactivated"
                        : "Active"}
                    </span>
                  </div>

                  <div className="flex-1">
                     <div className="group relative inline-block    ">
                    <span className=" text-[#0A0A0A] truncate  text-[24px] nunito-semibold ">

                          {selectedMember?.name?.length > 20
    ? `${selectedMember.name.slice(0, 20)}...`
    : selectedMember?.name || ""}
                    </span>
                    
                      {/* Tooltip on hover */}
                      <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-7  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                        <div className="text-start">
                          <div className="nunito-regular truncate text-[12px] text-[#696969] mb-1">
                            {selectedMember?.name}
                          </div>
                        </div>
                      </div>
                    </div>
<div className=" group relative">

                    <p className="text-[#404040]  truncate max-w-96 text-[14px] nunito-medium">
                      {selectedMember?.email}
                    </p>  
                       <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-5  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                                <div className="text-start">
                                  <div className="nunito-regular text-[12px]  truncate text-[#696969] mb-1">
                                                        {selectedMember?.email}

                                  </div>
                                </div>
                              </div>
</div>
                    <p className="text-[#696969] text-[14px] nunito-medium">
                        (
                        {getTeamRoleDisplay(
                          selectedMember?.userData?.teamRole ||
                            selectedMember?.role ||
                            "Expert"
                        )}
                        )
                      </p>

                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <Star className="w-[20px] h-[20px] text-[#F5A038] fill-[#F5A038]" />
                        <span className="ml-1 text-[#696969] text-[16px] nunito-regular">
                          {ratingsLoading[selectedMember?.id]
                            ? ""
                            : userRatings[
                                selectedMember?.id
                              ]?.avgRating?.toFixed(1) || "0.0"}
                        </span>
                        <span className="ml-1 text-[#696969] text-[16px] nunito-regular">
                          (
                          {ratingsLoading[selectedMember?.id]
                            ? ""
                            : userRatings[selectedMember?.id]?.totalReviews ||
                              "0"}{" "}
                          reviews)
                        </span>
                      </div>
                      <div className="text-[#404040] text-[12px] nunito-regular">
                        <span className="flex items-center gap-1">
                          <Clock className="w-[14px] h-[14px] text-[#696969]" />
                          {selectedMember?.lastActivityFull ||
                            ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 mx-3 mb-5">
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Total Sessions
                  </p>
                  <p className="text-[#F15D18] nunito-bold text-[20px]">
                    {selectedMember?.totalSessions || "0"}
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Rate per min
                  </p>
                  <p className="text-[#F15D18] nunito-bold text-[20px]">
                    ${Number(selectedMember?.ratePerMinute || 0).toFixed(2) || "0.00"}{" "}
                    <span className="text-[16px] nunito-bold">/min</span>
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Total Earnings
                  </p>
                  <p className="text-[#F15D18] nunito-bold text-[20px]">
                    ${selectedMember?.expertTotalEarnings.toFixed(2) || "0.00"}
                  </p>
                </div>
              </div>{" "}
              {selectedMember?.specialities &&
                Array.isArray(selectedMember.specialities) &&
                selectedMember.specialities.length > 0 && (
                  <div className="mx-3">
                    <div className="flex justify-between items-center mb-2">
                      <p className="text-[#696969] text-[16px] nunito-medium">
                        Specialties
                      </p>
                    </div>{" "}
                    <div className="grid grid-cols-2 gap-2 mb-3">
                      {selectedMember.specialities.map(
                        (specialty: string, index: number) => (
                          <div
                            key={index}
                            className="bg-[#FAFAFA] px-3 py-1 text-[#404040] rounded-[16px] text-[14px] nunito-semibold text-center"
                          >
                            {specialty}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              <div className="flex justify-end mb-3 mr-2  ">
                <button
                  className="text-[#696969]"
                  onClick={() => {
                    handleEdit(selectedMember);
                    setExpertModalOpen(false);
                  }}
                >
                  <Pencil className="w-[24px] h-[24px] text-[#696969]" />
                </button>
              </div>
            </div>
            {/* Organization section */}
            <div className="flex items-center p-4 bg-white rounded-[16px] border-[1px] border-[#C4C4C4] relative">
              <div className="mr-3">
                <Building2 className="w-[80px] h-[80px] stroke-[0.5px] text-[#000000]" />
              </div>
              <div className="flex-grow">
                <div className="flex justify-between items-center">
                  <h2 className="text-[20px] nunito-semibold truncate max-w-40 text-[#0A0A0A]">
                    {organizations[selectedMember?.orgId]?.name ||
                      "Organization"}
                  </h2>
                  <div className="flex items-center text-[#404040] text-[12px]">
                    <NotepadText className="w-[16px] h-[16px] mr-1 text-[#7B7B7B]" />
                    <span>
                      Tax ID:{" "}
                      {organizations[selectedMember?.orgId]?.taxId || "N/A"}
                    </span>
                  </div>
                </div>
                <div className="">
                  {" "}
                  <p className="text-[14px] nunito-medium text-[#404040]">
                    Website:{" "}
                    {organizations[selectedMember?.orgId]?.url || "N/A"}
                  </p>
                  <p className="text-[14px] nunito-medium text-[#404040]">
                    Address:{" "}
                    {selectedMember?.orgId &&
                    organizations[selectedMember.orgId]?.billingAddress
                      ? `${
                          organizations[selectedMember.orgId].billingAddress
                            ?.address_1 || ""
                        }, ${
                          organizations[selectedMember.orgId].billingAddress
                            ?.address_2 || ""
                        }, ${
                          organizations[selectedMember.orgId].billingAddress
                            ?.city || ""
                        }, ${getStateFullName(
                          organizations[selectedMember.orgId].billingAddress
                            ?.country || "",
                          organizations[selectedMember.orgId].billingAddress
                            ?.state || ""
                        )}, ${getCountryFullName(
                          organizations[selectedMember.orgId].billingAddress
                            ?.country || ""
                        )}, ${
                          organizations[selectedMember.orgId].billingAddress
                            ?.postcode || ""
                        }`
                          .trim()
                          .replace(/^,\s*|,\s*$/g, "")
                          .replace(/,\s*,/g, ",")
                      : ""}
                  </p>
                </div>
              </div>
              {/* <div className="absolute bottom-2 right-4">
                <button className="text-[#696969]" onClick={handleEditeOrgData}>
                  <Pencil className="h-[24px] w-[24px] text-[#696969]" />
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {deleteConfirmOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-black bg-opacity-50"></div>
          <div className="bg-white  w-[549px] rounded-lg shadow-[16px]  p-4 z-10">
            <div className="flex justify-end">
              <button
                className="text-gray-500 flex justify-end hover:text-gray-700"
                onClick={() => setDeleteConfirmOpen(false)}
              >
                <X className="w-[32px] h-[32px]" />
              </button>
            </div>
            <div className="flex justify-center items-center">
              <p className="text-[24px] nunito-semibold text-[#0A0A0A]">
                Are you sure you want to delete ?
              </p>
            </div>
            <div className="flex justify-center mt-7 space-x-4">
              <button
                className="py-3 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                onClick={() => {
                  setDeleteConfirmOpen(false);
                  setUserToDelete(null);
                }}
              >
                No
              </button>
              <button
                className="py-3 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                onClick={() => {
                  setDeleteConfirmOpen(false);
                  setUserToDelete(null);
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
